import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import Tw_Cen_MT_Negrita from '../../../../componentes/font/Tw_Cen_MT/TCB_____.TTF';
import Tw_Cen_MT from '../../../../componentes/font/Tw_Cen_MT/TCM_____.TTF';
import { ImagenTipoProducto } from "../../../../configuracion/apiUrls";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones";

Font.register({ family: 'Tw_Cen_MT', src: Tw_Cen_MT });
Font.register({ family: 'Tw_Cen_MT_Negrita', src: Tw_Cen_MT_Negrita });

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Tw_Cen_MT',
        fontSize: 10,
        paddingTop: 40,
        paddingBottom: 60,
        paddingHorizontal: 60,
        backgroundColor: '#ffffff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 5,
    },
    companyInfoLeft: { flexGrow: 1, textAlign: 'left' },
    companyName: { fontFamily: 'Tw_Cen_MT_Negrita', fontSize: 16, color: '#333', marginBottom: 3 },
    companyAddress: { fontSize: 9, color: '#666', marginBottom: 2 },
    logoContainer: { width: 100, height: 100, marginLeft: 20, marginTop: -10 },
    logo: { width: 100, height: 100, objectFit: 'cover', borderRadius: 15 },
    titleContainer: {
        marginTop: 10,
        marginBottom: 15,
        borderBottomWidth: 1,
        borderBottomColor: '#eee',
        paddingBottom: 5
    },
    reportTitleLabel: {
        fontSize: 12,
        fontFamily: 'Tw_Cen_MT_Negrita',
        color: '#666',
        textTransform: 'uppercase',
    },
    productNameTitle: {
        fontSize: 16,
        fontFamily: 'Tw_Cen_MT_Negrita',
        color: '#000',
        marginTop: 2
    },

    sectionTitle: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 10,
        backgroundColor: '#F5F5F5',
        color: 'black',
        padding: 4,
        textTransform: 'uppercase',
    },

    row: { flexDirection: 'row', gap: 10, marginBottom: 10 },
    sectionBox: { flex: 1, border: 0.5, borderColor: '#D0D0D0', borderRadius: 4, overflow: 'hidden' },
    content: { padding: 6 },

    infoLabel: { fontFamily: 'Tw_Cen_MT_Negrita', color: '#444', fontSize: 9 },
    infoText: { color: '#555', fontSize: 9 },
    catImage: { width: 60, height: 45, borderRadius: 4, marginTop: 3, border: 0.2, borderColor: '#eee' },

    table: { width: '100%', marginTop: 5 },
    tableHeader: { flexDirection: 'row', backgroundColor: '#F5F5F5', borderBottomWidth: 0.5, borderBottomColor: '#E0E0E0', paddingVertical: 2 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 0.2, borderBottomColor: '#F0F0F0', paddingVertical: 2 },
    colHeader: { fontFamily: 'Tw_Cen_MT_Negrita', fontSize: 7, textAlign: 'center', flex: 1 },
    colData: { fontSize: 7, textAlign: 'center', flex: 1 },

    footer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 8,
        color: '#888',
        paddingHorizontal: 60,
    }
});

const ReporteProducto = ({ producto }) => {
    if (!producto) return null;


    const urlImagenCategoria = `${ImagenTipoProducto}${producto.productoTipo?.imagen || "categoriasproductos.jpg"}`;

    const chunkLotes = (arr, size) => {
        return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
            arr.slice(i * size, i * size + size)
        );
    };
    const lotesAgrupados = chunkLotes(producto.lotes || [], 2);

    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                {/* ENCABEZADO */}
                <View style={styles.header}>
                    <View style={styles.companyInfoLeft}>
                        <Text style={styles.companyName}>{NegocioConfig.nombre}</Text>
                        <Text style={styles.companyAddress}>{NegocioConfig.direccion}</Text>
                        <Text style={styles.companyAddress}>RTN: {NegocioConfig.rtn} | Email: {NegocioConfig.correo}</Text>
                        <Text style={styles.companyAddress}>Tel: {NegocioConfig.telefono}</Text>
                    </View>
                    {NegocioConfig.logo && (
                        <View style={styles.logoContainer}>
                            <Image style={styles.logo} src={NegocioConfig.logo} />
                        </View>
                    )}
                </View>

                {/* TÍTULO SEPARADO */}
                <View style={styles.titleContainer}>
                    <Text style={styles.reportTitleLabel}>REPORTE DETALLADO DE PRODUCTO</Text>
                    <Text style={styles.productNameTitle}>{producto.nombre}</Text>
                </View>

                {/* INFORMACIÓN GENERAL */}
                <View style={styles.row}>
                    <View style={[styles.sectionBox, { flex: 2 }]}>
                        <Text style={styles.sectionTitle}>Información General</Text>
                        <View style={[styles.content, { flexDirection: 'row', gap: 10 }]}>
                            <View style={{ flex: 1 }}>
                                <Text style={styles.infoLabel}>CÓDIGO: <Text style={styles.infoText}>{producto.codigo}</Text></Text>
                                <Text style={[styles.infoLabel, { marginTop: 4 }]}>DESCRIPCIÓN:</Text>
                                <Text style={styles.infoText}>{producto.descripcion || "Sin descripción disponible"}</Text>
                                <View style={{ flexDirection: 'row', marginTop: 8 }}>
                                    <View style={{ width: '40%' }}>
                                        <Text style={styles.infoLabel}>TIPO:</Text>
                                        <Text style={styles.infoText}>{producto.tipo}</Text>
                                    </View>
                                    <View style={{ width: '60%' }}>
                                        <Text style={styles.infoLabel}>CATEGORÍA:</Text>
                                        <Image src={urlImagenCategoria} style={styles.catImage} />
                                        <Text style={[styles.infoText, { fontSize: 7, marginTop: 2 }]}>{producto.productoTipo?.nombre}</Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={styles.sectionBox}>
                        <Text style={styles.sectionTitle}>Métricas Clave</Text>
                        <View style={styles.content}>
                            {[
                                { label: 'Precio s/ Imp:', val: formatoMoneda(producto.precioSinImpuesto) },
                                { label: `ISV (${producto.impuesto}):`, val: formatoMoneda(producto.isvConImpuesto) },
                                { label: 'Precio Final:', val: formatoMoneda(producto.precioConImpuesto) },
                                { label: 'Costo Unit:', val: formatoMoneda(producto.costo) },
                                { label: 'Existencia:', val: producto.existencia },
                                { label: 'P. Reorden:', val: producto.puntoReorden },
                                { label: 'Estado:', val: producto.estado },
                            ].map((item, i) => (
                                <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 3 }}>
                                    <Text style={styles.infoLabel}>{item.label}</Text>
                                    <Text style={styles.infoText}>{item.val}</Text>
                                </View>
                            ))}
                        </View>
                    </View>
                </View>

                {/* SECCIÓN DE LOTES */}
                <Text style={[styles.sectionTitle, { marginBottom: 5 }]}>Detalle de lotes</Text>

                {lotesAgrupados.map((fila, indexFila) => (
                    <View key={indexFila} style={styles.row} wrap={false}>
                        {fila.map((lote, indexLote) => (
                            <View key={indexLote} style={styles.sectionBox}>
                                <View style={styles.content}>
                                    {/* Cabecera del Lote */}
                                    <View style={{ borderBottomWidth: 0.5, borderBottomColor: '#eee', paddingBottom: 3 }}>
                                        <Text style={styles.infoLabel}>Lote: <Text style={styles.infoText}>{lote.nombre_lote}</Text></Text>
                                        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                            <View style={{ flexDirection: 'column', flex: 1 }}>
                                                <Text style={styles.infoLabel}>Fecha: <Text style={styles.infoText}>{moment(lote.fecha_ingreso).format('DD/MM/YY')}</Text></Text>
                                                <Text style={styles.infoLabel}>Costo: <Text style={styles.infoText}>{formatoMoneda(lote.costo)}</Text></Text>
                                                <Text style={styles.infoLabel}>Precio: <Text style={styles.infoText}>{formatoMoneda(lote.precio)}</Text></Text>
                                                <Text style={styles.infoLabel}>Utilidad: <Text style={styles.infoText}>{formatoMoneda(lote.utilidad)}</Text></Text>
                                                <Text style={styles.infoLabel}>Estado: <Text style={styles.infoText}>{lote.estado}</Text></Text>
                                                <Text style={styles.infoLabel}>Ingreso: <Text style={styles.infoText}>{lote.cantidad}</Text></Text>
                                            </View>
                                            <View style={{ flexDirection: 'column', flex: 1 }}>
                                                <Text style={styles.infoLabel}>Existencia: <Text style={styles.infoText}>{lote.existencia}</Text></Text>
                                                <Text style={styles.infoLabel}>En Pedido: <Text style={styles.infoText}>{lote.enPedido}</Text></Text>
                                                <Text style={styles.infoLabel}>Reserva: <Text style={styles.infoText}>{lote.existenciaReserva}</Text></Text>
                                                <Text style={styles.infoLabel}>Vendido: <Text style={styles.infoText}>{lote.vendido}</Text></Text>
                                                <Text style={styles.infoLabel}>Anulado: <Text style={styles.infoText}>{lote.anulado}</Text></Text>
                                            </View>
                                        </View>
                                    </View>

                                    {lote.loteprecios && lote.loteprecios.length > 0 && (
                                        <View style={styles.table}>
                                            <Text style={[styles.infoLabel, { fontSize: 7, textAlign: 'center', marginBottom: 2 }]}>Escala de Precios</Text>
                                            <View style={styles.tableHeader}>
                                                <Text style={styles.colHeader}>Mín. Cantidad</Text>
                                                <Text style={styles.colHeader}>Precio Unit.</Text>
                                            </View>
                                            {lote.loteprecios.map((p, i) => (
                                                <View key={i} style={styles.tableRow}>
                                                    <Text style={styles.colData}>{p.cantidad}</Text>
                                                    <Text style={styles.colData}>{formatoMoneda(p.precio)}</Text>
                                                </View>
                                            ))}
                                        </View>
                                    )}

                                    {/* TABLA: UBICACIONES (LOTEINVENTARIOS) */}
                                    {lote.loteinventarios && lote.loteinventarios.length > 0 && (
                                        <View style={styles.table}>
                                            <Text style={[styles.infoLabel, { fontSize: 7, textAlign: 'center', marginBottom: 2, marginTop: 4 }]}>Ubicaciones</Text>
                                            <View style={styles.tableHeader}>
                                                <Text style={[styles.colHeader, { textAlign: 'left', flex: 2 }]}> Almacén</Text>
                                                <Text style={styles.colHeader}>Cant.</Text>
                                            </View>
                                            {lote.loteinventarios.map((inv, i) => (
                                                <View key={i} style={styles.tableRow}>
                                                    <Text style={[styles.colData, { textAlign: 'left', flex: 2 }]}>{inv.inventarioTipo?.nombre}</Text>
                                                    <Text style={styles.colData}>{inv.existencia}</Text>
                                                </View>
                                            ))}
                                        </View>
                                    )}
                                </View>
                            </View>
                        ))}
                        {/* Celda fantasma para mantener el ancho del 50% si solo hay un lote en la fila */}
                        {fila.length === 1 && <View style={{ flex: 1 }} />}
                    </View>
                ))}

                {/* PIE DE PAGINA */}
                <View style={styles.footer} fixed>
                    <Text style={{ fontFamily: 'Tw_Cen_MT_Negrita', fontSize: 9, marginBottom: 3 }}>
                        Documento de control interno - GRUPO ARESSA
                    </Text>
                    <Text>Generado el {moment().format('DD/MM/YYYY HH:mm:ss')}</Text>
                </View>
            </Page>
        </Document>
    );
};

export default ReporteProducto;